/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgProjectAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m3 22-.997-2V4H4v16l-1 2zM9 2h10v2h3v18H6V4h3V2zm2 2v2h6V4h-6zm8 4H9V6H8v14h12V6h-1v2z"
        fill="currentcolor"
      />
      <path d="M18 12h-8v-2h8v2zm0 3h-8v-2h8v2zm0 3h-8v-2h8v2z" fill="currentcolor" />
    </g>
  </Icon>
);
export { SvgProjectAlt as ProjectAlt };
